import { KPIElementController } from '@sas-dvr/ltjs-bird';
import { VisualizationState } from '@sas-dvr/internal-va-react-core/store/birdElement/visualizationState';
import { VisualElementControllerLoader } from './LoaderFactory';
import { map, filter, distinctUntilChanged } from 'rxjs/operators';
import { loadVisualization } from './loadVisualization';

export const loadKPIElementController: VisualElementControllerLoader = (
  visualController,
  visualElementController,
  unload$,
  myActions$,
  state$,
  deps
) => {
  if (!(visualElementController instanceof KPIElementController)) {
    throw new Error('Expected the controller to be a KPIElementController');
  }
  const visualId = deps.getKey(visualElementController);
  const contentId$ = state$.pipe(
    map((aState) => aState.birdElements.DataVisualizations[visualId]),
    filter(
      (myState): myState is Exclude<Required<typeof myState>, undefined> =>
        myState !== undefined && myState.contentId !== undefined
    ),
    distinctUntilChanged(),
    map((myState) => myState.contentId)
  );

  const loadVisualElement$ = loadVisualization(
    visualController,
    visualElementController,
    unload$,
    myActions$,
    state$,
    deps,
    {
      create: () => VisualizationState.actions.add(visualId, {}),
      delete: () => VisualizationState.actions.delete(visualId),
    },
    { contentId$ }
  );

  return loadVisualElement$;
};
